/*
 * @Descripttion:
 * @version:
 * @Author: jizhijun
 * @Date: 2020-05-09 11:57:09
 * @LastEditors: jizhijun
 * @LastEditTime: 2020-05-13 09:47:02
 */

/**
 * @module:  辅助功能模块
 * @author: Liang Huang
 * @date: 2019-09-23 15:12:38
 */
export default function utilMixin(hybrid) {
  var hybridJs = hybrid;
  var innerUtil = hybridJs.innerUtil;
  hybridJs.extendModule('util', [{
    // 打开二维码扫描
    namespace: 'scan',
    os: ['ywk']
  }, {
    // 从相册中选择图片
    namespace: 'selectImage',
    os: ['ywk'],
    params: {
      // 图片数量
      photoCount: 9,
      // 是否允许拍照，1：允许；0：不允许
      showCamera: 0,
      // 是否显示gif图片，1：显示；0：不显示
      showGif: 0,
      // 是否允许预览，1：允许，0：不允许
      previewEnabled: 1,
      // 已选图片，json数组格式，item为元素本地地址
      selectedPhotos: []
    }
  }, {
    // 选择文件
    namespace: 'selectFile',
    os: ['ywk'],
    params: {
      // 文件数量
      count: 9
    }
  }, {
    // 拍照获取图片
    namespace: 'cameraImage',
    os: ['ywk'],
    params: {
      // 宽度
      width: 720,
      // 压缩质量
      quality: 70
    }
  }, {
    // 打开本地文件
    namespace: 'openFile',
    os: ['ywk'],
    params: {
      path: ''
    },
    runCode: function runCode() {
      var rest = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        rest[_i] = arguments[_i];
      } // 兼容字符串形式


      var args = innerUtil.compatibleStringParamsToObject.call(this, rest, 'path');
      hybridJs.callInner.apply(this, args);
    }
  }, {
    // 下载文件
    namespace: 'downloadFile',
    os: ['ywk'],
    params: {
      file_name: '',
      file_type: '',
      size: '',
      url: ''
    }
  }, {
    // 导航
    namespace: 'navigateToLocation',
    os: ['ywk'],
    params: {
      location: '',
      longitude: '',
      latitude: ''
    }
  }]);
}